import React, { useEffect, useState, Suspense, useMemo } from 'react';
import { createStackNavigator, TransitionPresets } from '@react-navigation/stack';
import { routes } from './routes';
import { WELCOME_SCREEN, HOME_PAGE } from './routes';
import { useSelector, shallowEqual } from 'react-redux';
import { Platform } from 'react-native';
import FetchingDataScreen from '../../components/fetchingDataScreen';
import { getDataLoadingScreen } from '../../js/getDataLoadingScreen';
import { INITIAL_LOADER_SCREEN } from '../../config/Constant';

const Stack = createStackNavigator();

export const HomeNavigator = () => {
  // Combine selectors to reduce re-renders
  const { webAppWidgetsInfo, isLoggedIn, shownWelcomeScreen, isBookingFound } = useSelector(
    state => ({
      webAppWidgetsInfo: state.deviceConfigSlice.webAppWidgetsInfo,
      isLoggedIn: state.appConfigSlice.isLoggedIn,
      shownWelcomeScreen: state.appConfigSlice.shownWelcomeScreen,
      isBookingFound: state.checkInSlice.bookingStatus.isBookingFound,
    }),
    shallowEqual
  );

  const screenInfoAfterLoader = webAppWidgetsInfo?.screenInfoAfterLoader;

  const [initialRoute, setInitialRoute] = useState(null);

  const checkShowWelcomeScreen = () => {
    try {

      if (screenInfoAfterLoader?.showAfterScreen && !shownWelcomeScreen) {

        if ((isLoggedIn || isBookingFound) && screenInfoAfterLoader.showAfterLogin) {
          setInitialRoute(WELCOME_SCREEN);
          return;
        }

        if (!isLoggedIn && !isBookingFound) {
          setInitialRoute(WELCOME_SCREEN);
          return;
        }
      }

      setInitialRoute(HOME_PAGE)
    } catch (error) {
      setInitialRoute(HOME_PAGE)
      console.error('Error checking welcome screen display:', error);
    }
  };

  useEffect(() => {
    checkShowWelcomeScreen();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  // Render a loading view until initialRoute is set
  if (initialRoute === null) {
    return null; // Or a loading spinner, or a temporary screen
  }

  const navigator = (
    <Stack.Navigator
      screenOptions={{
        headerShown: false,
        cardStyle: { flex: 1 },
        ...TransitionPresets.SlideFromRightIOS,
        detachPreviousScreen: false,
        lazy: true,
      }}
      initialRouteName={initialRoute}
    >
      {routes.map((iterator) => (
        <Stack.Screen
          key={iterator.name}
          name={iterator.name}
          component={iterator.component}
          options={iterator.options}
        />
      ))}
    </Stack.Navigator>
  );

  return navigator;
};
